// Tree shaking for only Geography class
export { Geography } from '@rbilabs/common/dist/utils/geography';
